$(function () {

    window.mayrih = {};

    window.mayrih.form = ({

        init: function () {

            var _th = this;

            $('.js-phone').mask('+7(999) 999-9999');

            $('form').submit(function () {
                if (!_th.checkForm($(this)))
                    return false;
            });
        },

        checkForm: function (form) {
            var checkResult = true, re;
            form.find('.warning').removeClass('warning');
            form.find('input, textarea, select').each(function () {
                if ($(this).data('req')) {
                    switch ($(this).data('type')) {
                        case 'tel':
                            re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
                            if (!re.test($(this).val())) {
                                $(this).addClass('warning');
                                checkResult = false;
                            }
                            break;
                        case 'email':
                            re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
                            if (!re.test($(this).val())) {
                                $(this).addClass('warning');
                                checkResult = false;
                            }
                            break;
                        case 'checkbox_personal':
                            if (!$(this).is(':checked')) {
                                $(this).parents('.checkbox').addClass('warning');
                                checkResult = false;
                            }
                            break;
                        default:
                            if ($.trim($(this).val()) === '') {
                                $(this).addClass('warning');
                                checkResult = false;
                            }
                            break;
                    }
                }
            });
            return checkResult;
        }

    }).init();

    window.mayrih.location = ({

        map: function () {
            ymaps.ready(function() {
                var yMap = new ymaps.Map('map', {
                    zoom: 12,
                    center: [55.76, 37.64],
                    controls: ['default']
                });

                yMap.behaviors.disable('scrollZoom');

                document.querySelectorAll('.contacts__item').forEach(function (item) {
                    if (item.dataset.json) {
                        try {
                            var data = JSON.parse(item.dataset.json);
                            var position = [parseFloat(data.lat), parseFloat(data.lng)];
                            placemark = new ymaps.Placemark(position, {
                                balloonContentHeader: data.title,
                                balloonContentBody: data.content,
                            }, {
                                iconLayout: 'default#imageWithContent',
                                iconImageHref: '/static/i/svg/pin.svg',
                                iconImageSize: [32, 46],
                                iconImageOffset: [-16, -23],
                                hideIconOnBalloonOpen: false
                            });


                            yMap.geoObjects.add(placemark)

                        } catch (e) {
                            console.error(e);
                        }
                    }
                    yMap.setBounds(yMap.geoObjects.getBounds(),{checkZoomRange:true, zoomMargin:9});
                });
            });
        },

        init: function () {
            var _th = this;

            if ($('.js-map').length) {
                _th.map();
            }
        }

    }).init();


    //выцепляем яблоки, вешаем класс
    if (navigator.userAgent.match(/(iPod|iPhone|iPad)/)) {
        $('body').addClass('ios')
    }

    var $contentTables = $("table", ".text");

    if ($contentTables.length) {
        $contentTables.each(function () {
            $(this).wrap('<div class="table-wrap">');
        });
    }

    if ($('.js-burger').length) {
        $('.js-burger').on('click', function () {
            var _t = $(this),
                $body = $('body'),
                $nav = $('.navbar');

            if (!_t.hasClass('open')) {
                _t.addClass('open');
                $('.header').removeClass('anchors-active active')
                $nav.fadeIn(350);
                setTimeout(function () {
                    $body.addClass('open-menu');
                }, 200);
            } else {
                $body.removeClass('open-menu');
                setTimeout(function () {
                    $nav.fadeOut(350);
                    _t.removeClass('open');
                }, 300);
            }

            return false;
        })
    }

    if ($('.js-photo-slider').length) {
        var swiperPhoto = new Swiper('.js-photo-slider', {
            loop: false,
            speed: 700,
            slidesPerView: 'auto',
            spaceBetween: 6,
            grabCursor: true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
        });

        $(".js-photo-slider").lightGallery({
            selector: 'a'
        });
    }

    if ($('.js-product-slider').length) {
        var productSlider = new Swiper('.js-product-slider', {
            loop: false,
            speed: 350,
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
            mousewheel: false,
            grabCursor: false,
            keyboard: false,
            simulateTouch: false,
            allowSwipeToNext: false,
            allowSwipeToPrev: false,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
                renderBullet: function (index, className) {
                    const types = document.querySelectorAll('.product__info-class')
                    const currentType = types[index].textContent.replace('класс ', '')
                    return '<button type="button" class="' + className + '">' + currentType + '</button>';
                },
            }
        });
    }

    if ($('.js-product-toogle').length) {
        $('.js-product-toogle .product__docs-title').on('click', function () {
            var _th = $(this);
            if (!_th.parent('.js-product-toogle').hasClass('open')) {
                _th.parent('.js-product-toogle').addClass('open');
                _th.siblings('.product__docs-list').fadeIn(350);
            } else {
                _th.parent('.js-product-toogle').removeClass('open');
                _th.siblings('.product__docs-list').fadeOut(350);
            }
            return false;
        });
    }

    if ($('.js-select').length) {
        $('.js-select').styler({
            selectSmartPositioning: false,
        });
    }

    if ($(".js-lightgallery").length) {
        $(".js-lightgallery").lightGallery({
            selector: 'a.media__gallery-overimg'
        });
    }

    if ($(".js-gallery").length) {
        $(".js-gallery").lightGallery({
            selector: 'a'
        });
    }

    $('.js-close-popup').on('click', function () {
        $.magnificPopup.close();
        return false;
    });

    var $sub_titles = $('.text h2'),
        $anchors_container = $('.anchors');

    if ($anchors_container.length && $sub_titles.length) {
        var list = '';
        $sub_titles.map(function (i, item) {
            list += '<li class="anchors__list-item"><a class="anchors__list-href" href="#' + i + '" data-anchor="' + i + '">' + item.textContent + '</a></li>';
            item.setAttribute('data-anchor-item', i);
        });
        $anchors_container.find('.anchors__list').html(list);

        $('.anchors__list .anchors__list-href').on('click', function(event) {
            scrollToSection(event.target)
        })

    } else {
        var $parent = $anchors_container.closest('.main__sidebar_right');
        $anchors_container.remove();
        if($parent.children().length  === 0) {
            $parent.remove();
        }
    }


    $(window).scroll(function () {
        var vst = $(window).scrollTop(),
            vh = $(window).height(),
            wv = $(window).width(),
            per = $('.history__period'),
            perItem = $('.history__period-item');

        per.each(function () {
            var _t = $(this);
            var _tOffset = _t.offset().top + 50;
            if (_tOffset < vst + vh) {
                _t.addClass('show');
            }
        });

        perItem.each(function () {
            var _t = $(this);
            var _tOffset = _t.offset().top - 50;
            if (_tOffset < vst + vh) {
                _t.addClass('show');
            }
        });

        if ($('.js-swim').length && $('body.inside').length && $(window).width() > 1023) {
            var swimEl = $('.js-swim'),
                swimPar = swimEl.parents('.main'),
                mainRow = swimPar.find('.main__row'),
                mainRowOffset = swimPar.find('.main__row').offset();
            swimEl.each(function () {
                var _thSwim = $(this);
                if (mainRowOffset.top + (_thSwim.height() / 2) <= vst + vh / 2) {
                    _thSwim.addClass('fixed');
                    if ((vst + vh / 2 + _thSwim.height() / 2) >= mainRowOffset.top + mainRow.outerHeight(true) - 50) {
                        _thSwim.addClass('pos-bottom');
                    } else {
                        _thSwim.removeClass('pos-bottom');
                    }
                } else {
                    _thSwim.removeClass('fixed pos-bottom');
                }
            });
        } else {
            if ($('.js-swim').length && $('body.inside').length && $(window).width() < 1023) {
                $('.js-swim').each(function () {
                    $(this).removeClass('fixed');
                });
            }
        }

		if ($('.js-swim.navbar:not(.fixed)').length && wv > 1023) {
			var navbar = $('.js-swim.navbar'),
				navbarOffset = navbar.offset(),
				navbarHeight = navbar.height(),
				langHref = $('.footer__lang-href');

			if (navbarOffset.top + navbarHeight > vst + vh - 50) {
				langHref.fadeOut(350);
			} else {
				langHref.fadeIn(350);
			}

		} else {
			$('.footer__lang-href').fadeIn(350);
		}

    }).trigger('scroll');

    $(window).resize(function () {
        $(window).trigger('scroll');
    }).trigger('resize');

    if ($('.js-mfp')) {
        $('.js-mfp').magnificPopup({
            type: 'inline',
            midClick: true
        });
    }

    $('.js-mfp').on('click', function () {
        $('body').addClass('popup-open')
    })

    $('.social__item--wechat').on('click', function () {
        $('.wechat-popup').show();
    })

    $('.wechat-popup-close').on('click', function () {
        $('.wechat-popup').hide();
    })

    $('body').on('mousedown', '.mfp-close', function () {
        $('body').removeClass('popup-open')
    })

    $('.js-mfp-video').magnificPopup({
        disableOn: 700,
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        //fixedContentPos: false,
        midClick: true
    });

    $('.form .form__input, .form .form__textarea').on('change', function () {
        if ($(this).val() !== '') {
            $(this).addClass('not-empty');
        } else {
            $(this).removeClass('not-empty');
        }
    });

    $(document).on('click', function (e) {
        if ($(e.target).closest('.product__docs').length === 0 && $('.product__docs.open').length) {
            $('.js-product-toogle').removeClass('open');
            $('.product__docs-list').fadeOut(350);
        }
    });

    var forms = document.querySelectorAll('.js-form');
    forms.forEach(function (item) {
        var uploader = item.querySelector('.js-uploader');
        if (uploader) {
            uploader = (new TurboUploader(uploader));
            uploader.updateInputData = function () {
                var files = this.container.querySelectorAll('.js-file_uploader__file');
                this.input.value = '';
                var newValue = [];
                files.forEach(function (item) {
                    newValue.push({
                        identify: item.dataset.identify,
                        path: item.dataset.file_path
                    })
                });
                this.input.value = JSON.stringify(newValue);
                if (newValue.length) {
                    $(item).find('.uploaded-file__label').hide();
                } else {
                    $(item).find('.uploaded-file__label').show();
                }
            };
            uploader.old_add = uploader.add;
            uploader.add = function (e, data) {
                $(item).find('.uploaded-file__label').hide();
                this.old_add(e, data);
            }
        }

        var form = new TurboForm(item, {
            errorClass: 'warning',
            fieldLineClass: 'form__field',
            showErrorAfterInput: true,
            unholdFormAfterSuccess: false
        });

        form.showSuccessMessage = function (message) {
            var block = $(this.form).closest('.js-form-root').find('.form-success-block');
            block.find('.popup__text').html(message);
            block.show().siblings().hide();
        };

        form.showPreloader = function () {
            $('.js-preloader', this.form).show();
        };

        form.hidePreloader = function () {
            $('.js-preloader', this.form).removeAttr('style');
        };
    })
});


document.addEventListener('DOMContentLoaded', function (){
    function buttonGoUp(){
        const buttonUp = document.querySelector('.button-up') || false;

        if (buttonUp){
            function checkScroll(){
                if (window.scrollY > 100){
                    buttonUp.classList.add('active')
                    buttonUp.addEventListener('click', goUp)
                }else{
                    buttonUp.classList.remove('active')
                    buttonUp.removeEventListener('click', goUp)
                }
            }

            function goUp() {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth',
                })
            }
            checkScroll();

            window.addEventListener('scroll', checkScroll)
        }
    }

    function changeUrlFromSpan(){
        const links = document.querySelectorAll('.js-change-location') || false;
        if (links){
            links.forEach(function (link){
                link.addEventListener('click', function (){
                    const url = link.getAttribute('data-href')
                    window.location.href = window.location.origin + url;
                })
            })
        }
    }

    function sharePage() {
        const shareElement = document.querySelector(".js-share-page") || false;
        var notificationCopy = document.querySelector(".social__notification--copy") || false;
        var notificationCopyFooter = document.querySelector(".social__notification--footer") || false ;
        var timeoutID;
        function timerNotification(){
            clearTimeout(timeoutID)
            if (notificationCopy && notificationCopyFooter) {
                if (window.innerWidth <= 768) {
                    notificationCopyFooter.classList.add('active')
                } else {
                    notificationCopy.classList.add('active')
                }
                timeoutID = setTimeout(function () {
                    notificationCopy.classList.remove('active')
                    notificationCopyFooter.classList.remove('active')
                }, 2000)
            }
        }

        if (shareElement){
            shareElement.addEventListener("click", function (){
                try {
                    navigator.clipboard.writeText(document.location.href);
                    timerNotification()
                } catch (err) {
                    console.log('Скопировать ссылку не удалось')
                }
            })
        }
    }

    buttonGoUp();
    changeUrlFromSpan();
    sharePage();
})


function scrollToSection (item) {
    var _th = $(item),
        _thData = _th.data('anchor'),
        content = $('.main__content');

    if (content.find('[data-anchor-item="' + _thData + '"]').length) {
        $("html, body").animate({scrollTop: $('[data-anchor-item="' + _thData + '"]').offset().top - 150}, 800);
    }
    return false;
}


mapStyleRulle = [
    {
        "featureType": "administrative",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#444444"
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "all",
        "stylers": [
            {
                "color": "#f2f2f2"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "saturation": "-100"
            },
            {
                "lightness": "57"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "lightness": "1"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "labels",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "all",
        "stylers": [
            {
                "saturation": -100
            },
            {
                "lightness": 45
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "simplified"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "transit",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "transit.station.bus",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "transit.station.bus",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "saturation": "0"
            },
            {
                "lightness": "0"
            },
            {
                "gamma": "1.00"
            },
            {
                "weight": "1"
            }
        ]
    },
    {
        "featureType": "transit.station.bus",
        "elementType": "labels.icon",
        "stylers": [
            {
                "saturation": "-100"
            },
            {
                "weight": "1"
            },
            {
                "lightness": "0"
            }
        ]
    },
    {
        "featureType": "transit.station.rail",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "transit.station.rail",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "gamma": "1"
            },
            {
                "lightness": "40"
            }
        ]
    },
    {
        "featureType": "transit.station.rail",
        "elementType": "labels.icon",
        "stylers": [
            {
                "saturation": "-100"
            },
            {
                "lightness": "30"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "all",
        "stylers": [
            {
                "color": "#d2d2d2"
            },
            {
                "visibility": "on"
            }
        ]
    }
];


function debounce(func, delay) {
    var timeout = null

    return function (args) {
        if (timeout) {
            clearTimeout(timeout)
        }

        timeout = setTimeout(function () {
            func(args)
        }, delay)
    }
}


const getElementsClosestToCenter = function (selector) {
    const itemsList = document.querySelectorAll(selector);
    const itemsTop = [];
    itemsList.forEach(function (item) {
        itemsTop.push({
            item: item,
            top: item.getBoundingClientRect().top
        })
    })
    itemsTop.sort(function (a, b) {
        return a < 0 ? -1 : Math.abs(window.innerHeight / 2 - a.top) - Math.abs(window.innerHeight / 2 - b.top);
    })
    return itemsTop
}

const returnedFunction = debounce(function (selector) {
    if (document.querySelectorAll(selector).length) {
        const elements = getElementsClosestToCenter(selector);
        const currentItem = elements[0];
        const sectionId = currentItem.item.dataset.anchorItem;
        var section = null;
        var activeItem = null;

        if (window.innerWidth > 1023) {
            section = document.querySelector('a.anchors__list-href[data-anchor= "' + sectionId + '"]');
            activeItem = document.querySelector('a.anchors__list-href.active');
        }
        else {
            section = document.querySelector('span.anchors__list-href[data-anchor= "' + sectionId + '"]');
            activeItem = document.querySelector('span.anchors__list-href.active');
        }

        if (activeItem || activeItem && currentItem.top > window.innerHeight){
            activeItem.classList.remove('active');
        }
        if (currentItem.top < window.innerHeight) {
            section.classList.add('active');
        }
    }
}, 100);


var previousPosition = window.scrollY || document.documentElement.scrollTop;

const showHeader = function () {
    const header = document.querySelector('.header');
    const stickyAnchors = document.querySelector('.anchors');

    var currentPosition = window.scrollY || document.documentElement.scrollTop;

    if (window.innerWidth < 1023 && previousPosition >= currentPosition && currentPosition !== 0 ) {
        header.classList.add('active')
        if (stickyAnchors && stickyAnchors.getBoundingClientRect().top < 0) {
            header.classList.add('anchors-active')
        }
        else {
            header.classList.remove('anchors-active')
        }
    }
    else {
        header.classList.remove('active')
        header.classList.remove('anchors-active')
    }

    previousPosition = currentPosition
}

const copyStickyAnchors = function () {
    const anchors = document.querySelectorAll('.anchors__list-href');
    if (!anchors.length) return
    anchors.forEach(function(anchor, index) {
        const anchorText = anchor.textContent;
        const anchorLink = anchor.dataset.anchor;
        const headerAnchors = document.querySelector('.header__anchors .anchors__list');
        const newAnchor = document.createElement('span');
        const dot = document.createElement('span')
        newAnchor.textContent = anchorText;
        newAnchor.setAttribute('data-anchor', anchorLink);
        newAnchor.classList.add('anchors__list-href');
        dot.classList.add('anchors__dot')
        headerAnchors.append(newAnchor);
        if (anchors.length !== index + 1) {
            headerAnchors.append(dot)
        }
    })
}

document.querySelector('body').addEventListener('click', function (e) {
    const anchor = e.target.closest('.header__anchors .anchors__list-href')
    if (anchor) {
        scrollToSection(anchor)
    }
})

window.addEventListener('scroll', function () {
    if (!document.querySelector('body').classList.contains('open-menu')) {
        showHeader()
    }
    returnedFunction('h2[data-anchor-item]');
});

window.addEventListener('resize', function () {
    returnedFunction('h2[data-anchor-item]');
});

document.addEventListener("DOMContentLoaded", function () {
    copyStickyAnchors();
    returnedFunction('h2[data-anchor-item]');
});
